// extracted by mini-css-extract-plugin
export default {"melodyVideo":"xP-z","isFullWidth":"yP-z","landingPageVideo":"zP-z","play":"AP-z","iframeVideo":"BP-z","playHidden":"CP-z","fullwidth":"DP-z"};